import React from "react";
import HRLayout from "../layout/HRLayout";

const Payroll = () => {
  const data = [
    {
      name: "Sonam",
      salary: 50000,
      allowance: 5000,
      deduction: 5000,
      net: 50000,
      status: "Approved",
    },
  ];

  return (
    <HRLayout>
      <h2 className="text-2xl font-bold mb-4">Payroll Management</h2>

      {/* SEARCH + BUTTON */}
      <div className="flex justify-between mb-4">
        <input
          placeholder="Search employee..."
          className="border p-2 rounded w-1/3"
        />
        <button className="bg-green-600 text-white px-4 py-2 rounded">
          + Generate Payroll
        </button>
      </div>

      {/* TABLE */}
      <div className="bg-white rounded shadow">
        <table className="w-full">
          <thead className="border-b">
            <tr>
              <th className="p-3">Employee</th>
              <th>Salary</th>
              <th>Allowance</th>
              <th>Deduction</th>
              <th>Net</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, i) => (
              <tr key={i} className="border-b">
                <td className="p-3">{item.name}</td>
                <td>₹{item.salary}</td>
                <td>₹{item.allowance}</td>
                <td>₹{item.deduction}</td>
                <td>₹{item.net}</td>
                <td>
                  <span className="bg-green-100 text-green-600 px-2 py-1 rounded text-sm">
                    {item.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </HRLayout>
  );
};

export default Payroll;